import React from "react";
import { FiEdit2, FiEye, FiTrash2 } from "react-icons/fi";

export default function ClientTable({
  clients,
  onEdit,
  onView,
  onDelete,
}) {
  return (
    <div className="overflow-hidden rounded-lg border bg-white shadow-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="px-4 py-3 font-semibold">Client Name</th>
              <th className="px-4 py-3 font-semibold">PAN</th>
              <th className="px-4 py-3 font-semibold">GSTIN</th>
              <th className="px-4 py-3 font-semibold">Contact Person</th>
              <th className="px-4 py-3 font-semibold">Mobile</th>
              <th className="px-4 py-3 font-semibold">Status</th>
              <th className="px-4 py-3 font-semibold">Portal</th>
              <th className="px-4 py-3 font-semibold">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {clients.length === 0 ? (
              <tr>
                <td colSpan="8" className="px-4 py-8 text-center text-gray-500">
                  No clients found.
                </td>
              </tr>
            ) : (
              clients.map((client) => (
                <tr key={client.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium text-gray-900">
                    {client.name}
                  </td>
                  <td className="px-4 py-3">{client.pan || "—"}</td>
                  <td className="px-4 py-3">{client.gstin || "—"}</td>
                  <td className="px-4 py-3">
                    {client.contactPerson || client.contact || "—"}
                  </td>
                  <td className="px-4 py-3">{client.mobile || "—"}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`rounded-full px-2 py-1 text-xs font-medium ${
                        (client.status || "Active") === "Active"
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-200 text-gray-700"
                      }`}
                    >
                      {client.status || "Active"}
                    </span>
                  </td>
                  <td className="px-4 py-3"><span className={`rounded-full px-2 py-1 text-xs font-medium ${client.portalEnabled ? "bg-violet-100 text-violet-700" : "bg-gray-100 text-gray-600"}`}>{client.portalEnabled ? (client.portalAccessStatus || "Enabled") : "Off"}</span></td>
                  <td className="px-4 py-3">
                    <div className="flex flex-wrap gap-2">
                      <button
                        type="button"
                        onClick={() => onEdit(client)}
                        className="inline-flex min-w-[88px] items-center justify-center gap-1 rounded bg-yellow-100 px-3 py-1.5 font-medium text-yellow-800 hover:bg-yellow-200"
                      >
                        <FiEdit2 /> Edit
                      </button>

                      <button
                        type="button"
                        onClick={() => onView(client)}
                        className="inline-flex min-w-[88px] items-center justify-center gap-1 rounded bg-[#0B1F33] px-3 py-1.5 font-medium hover:bg-[#163A5F]"
                        style={{ color: "#ffffff" }}
                      >
                        <FiEye /> View
                      </button>

                      {onDelete && <button
                        type="button"
                        onClick={() => onDelete(client)}
                        className="inline-flex min-w-[88px] items-center justify-center gap-1 rounded bg-red-600 px-3 py-1.5 font-medium hover:bg-red-700"
                        style={{ color: "#ffffff" }}
                      >
                        <FiTrash2 /> Delete
                      </button>}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
